// Search params of the price list pages (route entry chunk: no zod, no
// heavy imports).
import { isPriceListFilter, type PriceListFilter, type PriceListKind } from "./api";

export type PriceListImport = "price_list_lines" | "purchase_price_list_lines";

export interface PriceListSearch {
  status: PriceListFilter;
  q: string;
  pl?: string | undefined;
  import?: PriceListImport | undefined;
}

export const importEntityOf = (kind: PriceListKind): PriceListImport =>
  kind === "purchase" ? "purchase_price_list_lines" : "price_list_lines";

export function validatePriceListSearch(kind: PriceListKind, raw: Record<string, unknown>): PriceListSearch {
  const s: PriceListSearch = {
    status: isPriceListFilter(raw.status) ? raw.status : "open",
    q: typeof raw.q === "string" ? raw.q.slice(0, 40) : "",
  };
  if (typeof raw.pl === "string" && raw.pl && raw.pl.length <= 64) s.pl = raw.pl;
  if (raw.import === importEntityOf(kind)) s.import = importEntityOf(kind);
  return s;
}
